import { AccountClient } from "client/aible/account";
import { DatasetClient } from "client/aible/dataset";
import { ClientFactory } from "client/base";
import { ProjectClient } from "client/aible/project";
import { CommentClient } from "client/aible/comment";
import { RatingClient } from "client/aible/rating";
import { ContentGenerationClient } from "client/aible/content_generation";
import { LanguageModelArtifactClient } from "client/aible/language_model_artifact";
import { ChatToneClient } from "client/aible/chat_tone";
export class AibleClientFactory {
    base;
    static INSTANCE = new AibleClientFactory(ClientFactory.getBaseClient());
    account;
    comment;
    rating;
    contentGeneration;
    dataset;
    project;
    artifact;
    tone;
    constructor(base) {
        this.base = base;
        this.account = new AccountClient(this.base);
        this.comment = new CommentClient(this.base);
        this.rating = new RatingClient(this.base);
        this.contentGeneration = new ContentGenerationClient(this.base);
        this.dataset = new DatasetClient(this.base, this.account);
        this.project = new ProjectClient(this.base, this.account);
        this.artifact = new LanguageModelArtifactClient(this.base, this.account);
        this.tone = new ChatToneClient(this.base);
    }
    getAccountClient() {
        return this.account;
    }
    getCommentClient() {
        return this.comment;
    }
    getContentGenerationClient() {
        return this.contentGeneration;
    }
    getDatasetClient() {
        return this.dataset;
    }
    getRatingClient() {
        return this.rating;
    }
    getProjectClient() {
        return this.project;
    }
    getLanguageModelArtifactClient() {
        return this.artifact;
    }
    getChatToneClient() {
        return this.tone;
    }
    static getInstance() {
        return this.INSTANCE;
    }
}
